import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';
import { EventService } from '../event.service';
import { Subscription } from 'rxjs';
import { SnackbarService } from '../snackbar.service';

@Component({
  selector: 'app-my-shippers',
  templateUrl: './my-shippers.component.html',
  styleUrls: ['./my-shippers.component.scss']
})
export class MyShippersComponent implements OnInit {
  shippersArr = [];
  showLoader = false;
  pendingInvites;
  // shipperColumn = ['sNo', 'name', 'address', 'action'];
  shipperColumn = ['sNo', 'name', 'address'];
  helpData = [
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];

  carrierUpdates: Subscription;

  constructor(private http: HttpService, private events: EventService, private snackbar: SnackbarService) { }

  ngOnInit() {
    this.getShippers();
    this.fetchPendingInvites();
    this.carrierUpdates = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getShippers();
      }
    );
  }

  fetchPendingInvites(){
    this.http.get('shippers/invite').subscribe(
      (response: any) => {
        this.pendingInvites = response.data;
      }
    )
  }
  inviteShipper(invite, type){
    let request = {
      _id: invite._id,
      accept: type
    };

    this.http.post('shippers/invite', request).subscribe(
      (resp: any) => {
        if (resp.statusCode === 200) {
          const msg = type ? 'Invite Accepted' : 'Invite Rejected';
          this.snackbar.openSnackBar(msg);
          this.fetchPendingInvites();
          this.getShippers();
        }
      },
      (err: any) => {
        if (err.error.statusCode === 403) {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      }
    );
  }
  ngOnDestroy() {
    this.carrierUpdates.unsubscribe();
  }

  getShippers() {
    this.showLoader = true;
    this.http.get('shippers').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          this.shippersArr = [];
          const result = data.data;
          result.forEach((element, i) => {
            const temp: any = {};
            temp.sNo = i + 1;
            temp.name = element.name;
            temp.parent_name = element.parent_name;
            temp.address = (element.location) ? element.location.area : 'N/A';
            temp.action = '';
            this.shippersArr.push(temp);
          });
        }
      },
      (err: any) => {
        console.log(err.error.message);
      }
    );
  }
}
